import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize Sentry error monitoring (only when a DSN is configured)
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
  });
}

const renderApp = () => {
  try {
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      throw new Error('Root element not found in the document!');
    }
    createRoot(rootElement).render(<App />);
  } catch (error) {
    console.error('Failed to render application:', error);
    if (SENTRY_DSN) Sentry.captureException(error);
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; font-family: sans-serif; padding: 20px; text-align: center;">
          <h1 style="color: #e53e3e; margin-bottom: 1rem;">Application Failed to Load</h1>
          <p style="margin-bottom: 1rem;">There was a problem loading the application. Please try refreshing the page.</p>
          <button
            style="background-color: #3182ce; color: white; padding: 0.5rem 1rem; border: none; border-radius: 0.25rem; cursor: pointer;"
            onclick="window.location.reload()">
            Reload Page
          </button>
        </div>
      `;
    }
  }
};

renderApp();
